'use client'

import { useParams } from 'next/navigation'
import { useMemo } from 'react'
import { fetchKDTKlassAttrThunk } from 'stores/courses'
import { axiosErrorHandler } from '@/shared/utils/axiosErrorHandler'
import KlassDetail from '../components/KlassDetail'
import { useDispatch } from 'react-redux'

const KDTDetail = () => {
  const params = useParams()
  const schoolId = params.id as string

  const dispatch = useDispatch()
  if (schoolId) {
    try {
      dispatch(fetchKDTKlassAttrThunk(schoolId))
    } catch (e) {
      axiosErrorHandler(e)
    }
  }
  return <KlassDetail schoolId={schoolId} />
}

export default KDTDetail
